export const MESSAGES = {
    FOLDERS_LOADING_ERROR: "Failed to load folders.",
    SOMETHING_WENT_WRONG_ERROR: "Something went wrong while loading folders.",
    FILE_UPLOADED: "File uploaded successfully!",
    FILE_UPLOAD_FAILED: "Failed to upload file.",
    FOLDER_CREATED: "Folder created Successfully!",
    FOLDER_CREATION_FAILED: "Failed to create folder",
    FOLDER_ACCESS_ADDED: "Folder access updated successfully",
    FOLDER_ACCESS_ADD_FAIL: "Failed to update folder access",
    FILE_ACCESS_ADDED: "File access updated successfully",
    FILE_ACCESS_ADD_FAIL: "Failed to update file access",
    FILE_DELETED: "File deleted successfully!",
    USER_FETCH_FAIL : "Failed to fetch users",
    MOBILE_WRITE_FAIL: "Documents directory failed, falling back to Download",
    FAIL_TO_FETCH_FILE: "Failed to fetch file.",
    FILE_DOWNLOAD_FAILED: "Failed to download file.",
    FILE_DOWNLOAD_SUCCESS: "File downloaded successfully!",
    FAILED_LOAD_MY_DRIVE: "Failed to load My Drive.",
    FAILED_LOAD_SHARED_DRIVE: "Failed to load Shared Drive.",
    ADD_FOLDER_PROMPT: "Enter folder name:",
    MY_DRIVE_EMPTY_MSG: "Your drive is empty. Create a folder or upload files.",
    SHARED_DRIVE_EMPTY_MSG: "No shared folders or files available.",
}

export const FOLDER_TYPES = {
  MY: "my",
  SHARED: "shared",
};

export const ACTIVE_TAB = {
  ALL: "all",
  SELECTED: "selected",
};

export const TARGET_TYPE = {
  FILE: "file",
  FOLDER: "folder",
};

export const FOLDER_NAMES = {
    MY_DRIVE: "My Drive",
    SHARED_DRIVE: "Shared Drive",
}